import { PropsWithChildren } from 'react'
import { cn } from '@scalis/utils'
import { Avatar } from '../avatar'
import { Body, BodySize, Caption, CaptionColor } from '../typography'
import { UserInfoProps } from './user-info.types'

export const UserInfo = ({
  src,
  fullName,
  email,
  onClick,
  disabled,
  children,
  color,
}: PropsWithChildren<UserInfoProps>) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={cn('flex items-center gap-2', onClick && 'cursor-pointer', disabled && 'cursor-default opacity-50')}
    >
      <Avatar
        src={src}
        fullName={fullName}
      />
      <div className='flex flex-col'>
        <Body size={BodySize.small}>{fullName}</Body>
        {email && <Caption color={CaptionColor.secondary}>{email}</Caption>}
      </div>
      <div className='ml-auto flex items-center gap-2'>
        {color && (
          <div
            className='square h-4 w-4 rounded-xs'
            style={{ backgroundColor: color }}
          />
        )}
        {children && <div className=''>{children}</div>}
      </div>
    </div>
  )
}
